import type { TFunction } from 'i18next'
import { OrderOption } from 'src/services/helpers/orderOptionParams'

export function getMarketListOrderChoices(t: TFunction) {
  return [
    {
      value: OrderOption.trending,
      label: t('common:order-option.trending'),
    },
    {
      value: OrderOption.mostLiked,
      label: t('common:order-option.most-liked'),
    },
    {
      value: OrderOption.mostUsed,
      label: t('common:order-option.most-used'),
    },
    {
      value: OrderOption.newest,
      label: t('common:order-option.newest'),
    },
  ]
}

export function getBookmarkListOrderChoices(t: TFunction) {
  return [
    {
      label: t('common:order-option.oldest'),
      value: OrderOption.oldest,
    },
    {
      label: t('common:order-option.newest'),
      value: OrderOption.newest,
    },
  ]
}
